export default {
  title:
    'https://mylink.oss-accelerate.aliyuncs.com/paradise/%E4%BB%BB%E5%8A%A1%E4%B8%AD%E5%BF%83%E4%B9%90%E5%9B%AD%20%E2%80%93%20%E5%85%B6%E4%BB%96%E6%83%85%E5%86%B5%E5%88%87%E5%9B%BE_slices/%E4%B8%BB%E6%A8%99%E9%A1%8C%402x%281%29.png',
  c1: '我的电子券',
  c2: '本月累计签到',
  c2_1: '天',
  c3: '积分说明',
  c4: '启用积分码',
  c5: '任务乐园',
  c5_1: ' ',
  c6: '积分明细',
  c7: '今日签到',
  c8: '明日签到',
  c9: '去完成',
  c10: '已完成',
  score109: '本月累计签到 ',
  score109_1: ' 天',
  score109_2: ' 天',
  score110: '累计签到7天可获得额外积分（每月限领一次）',
  score111: '签到提醒',
  score112: '签到提醒说明',
  score113:
    '打开开关后，若本月签到次数不满3次时，将于本月的15号、20号推送APP提醒签到，关闭则不提醒。',
  score125: '已签到',
  score126: '今日签到',
  score127: '双倍积分',
  score128: '累计签到满7天可获得额外大礼包哦',
  score129: '立即签到',
  score130: '签到成功',
  score131: '+',
  score131_2: '积分',
  score155: '启⽤积分码',
  score156: '积分明细',
  score157: '请输入积分码',
  score158: '请输入验证码',
  score159: '发送',
  score160: '立即启用',
  score161: 'MyLink积分码的条款及细则',
  score162:
    '1. MyLink积分码只适用于使用流动电话号码注册MyLink应用程式 (「MyLink」)之MyLink账号，并不适用于使用家居宽频号码注册之MyLink账号 (「合资格用户」)。',
  score163:
    '2. 合资格用户可通过MyLink活动或MyLink合作商户中获得MyLink积分码，用于兑换MyLink积分。合资格用户可于MyLink积分码有效期内，于MyLink「我的积分」à「启用积分码」以输入积分码及验证码（验证码将以短讯形式发送至MyLink登入账号的流动电话号码）兑换MyLink积分。成功兑换MyLink积分后，合资格用户可以在MyLink「我的积分」-「积分明细」查询有关详情。',
  score164:
    '3. 除非另有规定，每个MyLink积分码只能使用一次。合资格客户可于商户发送MyLink积分码时所展示之条款及细则查阅其MyLink积分码之指定兑换有效期。MyLink积分码必须于指定兑换有效期前，于MyLink兑换成MyLink积分。MyLink积分码逾期将作废并自动注销，且不获补发或延长兑换有效期。',
  score165:
    '4. 所有MyLink积分码均不可兑换现金或其他产品或服务，亦不能更换丶退款丶转售，亦不能与其他优惠同时使用。',
  score166:
    '5. 以MyLink积分码兑换之MyLink积分使用有效期：每年1月1日至6月30日期间以MyLink积分码兑换的MyLink积分，将于下一年的6月30日过期；每年7月1日至12月31日MyLink积分码兑换的MyLink积分将于下一年的12月31日过期。MyLink积分条款及细则详情请查看',
  score166_link:
    'https://eshop.hk.chinamobile.com/tc/corporate_information/Mylink/mylinkpoints.html。',
  score166_1:
    '6. 任何非本条款及细则的一方的人并不享有第623章《合约(第三者权利)条例》下的权利以执行本条款及细则任何条款或享有本条款及细则任何条款下的权益。',
  score166_2:
    '7. 如法院裁定本条款及细则内任何条款无效或不可强制执行，其余条款将不受上述无效或不可强制执行影响，并将继续具十足效力及作用。',
  score166_3:
    '8. 本条款及细则受香港特别行政区法律管辖，而用户均同意受香港法院的专有审判权所限。',
  score166_4: '9. 如有任何争议，中国移动香港将保留一切最终决定权。',
  score166_5: '10. 本条款及细则之中英文版本如有歧异，以中文版本为准。',
  score167: '积分码错误',
  score167_1: '积分码已过期',
  score167_2: '积分码已使用',
  score167_3: '积分码已废弃',
  score168: '验证码错误',
  score169: '积分',
  score170: '可到积分详细查看',
  score184: '取消',
  score200: '提提您',
  score201: '您的操作过于频繁或积分兑换金额过多，请稍后再试。',
  2: '移动地图，参观乐园',
  c12: '双指放大缩细，参观乐园',
  c13: '下一步',
  c14: '我知道了',
  c15: '你已分享3次了，下周再来～',
  c16: '左右滑动, 发掘未完成的任务',
  c17: '网络异常，请再试',
  c18: '你今日已签到',
  c19: 'https://mylink.oss-accelerate.aliyuncs.com/paradise/%E6%B5%AE%E7%AA%97-%E7%B9%81%E4%BD%93%402x%20%281%29.png',
  c20: '任务列表',
  c21: '点我开盲盒!',
  c22: '明天再来开盲盒~',
  c23: '盲盒中奖记录',
  c24: '"每日签到"改成"幸运盲盒日日赏"啦~',
  c25: '快去开盲盒拿惊喜',
  c26: '去开盲盒',
  c27: '「每天签到」已经升级為「幸运盲盒日日赏」啦, 马上去开盲盒拿惊喜!',
  c29: '今天还有2次机会',
  c30: 'https://mylink.oss-accelerate.aliyuncs.com/paradise/9.3/sc%402x.png',
  c31: 'https://mylink.oss-accelerate.aliyuncs.com/paradise/9.3/%E6%A0%87%E9%A2%98sc%402x3.png',
  c32: 'https://uatoss.mylinkapp.hk/via/atv/fan-model/index.html?lang=sc#/home',
  c33: '金融',
  c34: '保险',
  c35: '证券',
  c36: '汇款',
  c37: '购物',
  c38: '去完成',
  c39: '已完成',
  c40: '已结束',
  c41:'去看看',
  c42:'今日奖励发完了，明天再来看看吧',
  c43:'当前任务奖励已领取，看看其他任务吧',
  c44:'好的',
}
